const PROD_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT =
  "https://data.erste-am.com/gem/erste-am/chart/GEM_GRAPHICDATA_PERFORMANCE";
const PROD_GEM_FUNDLIST_ENDPOINT = "https://data.erste-am.com/gem/erste-am/GEM_FUNDLIST";
const PROD_GEM_FACTSHEET_ENDPOINT =
  "https://data.erste-am.com/gem/erste-am/GEM_FACTSHEET;ddsSources=WARNINGS,WARNINGS_META,ESMA_TEXT_ONLY";

const ERSTE_REAL_ESTATE_GRAPHICDATA_PERFORMANCE_ENDPOINT =
  "https://data.erste-am.com/gem/erste-immobilien/chart/GEM_GRAPHICDATA_PERFORMANCE";
const ERSTE_REAL_ESTATE_FUNDLIST_ENDPOINT =
  "https://data.erste-am.com/gem/erste-immobilien/GEM_FUNDLIST";
const ERSTE_REAL_ESTATE_FACTSHEET_ENDPOINT =
  "https://data.erste-am.com/gem/erste-immobilien/GEM_FACTSHEET;ddsSources=WARNINGS,WARNINGS_META,ESMA_TEXT_ONLY";

const ABU_ONLINE_PROD_GEM_FUNDLIST_ENDPOINT =
  "https://eam-data-int.prod.erste-group.net/gem/abuonline/GEM_FUNDLIST";
const ABU_ONLINE_PROD_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT =
  "https://eam-data-int.prod.erste-group.net/gem/abuonline/chart/GEM_GRAPHICDATA_PERFORMANCE";
const ABU_ONLINE_PROD_GEM_FACTSHEET_ENDPOINT =
  "https://eam-data-int.prod.erste-group.net/gem/abuonline/GEM_FACTSHEET;ddsSources=WARNINGS,WARNINGS_META,ESMA_TEXT_ONLY";

const UAT_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT =
  "https://data-uat.erste-am.com/gem/erste-am/chart/GEM_GRAPHICDATA_PERFORMANCE";
const UAT_GEM_FUNDLIST_ENDPOINT = "https://data-uat.erste-am.com/gem/erste-am/GEM_FUNDLIST";
const UAT_GEM_FACTSHEET_ENDPOINT =
  "https://data-uat.erste-am.com/gem/erste-am/GEM_FACTSHEET;ddsSources=WARNINGS,WARNINGS_META,ESMA_TEXT_ONLY";

const DEV_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT =
  "https://datahub.dev.erste-group.net/datahubService/data/dds/chart/byname/GEM_GRAPHICDATA_PERFORMANCE;serverFormatBy=DEFAULT;ungroupedColumn=ISIN;groupName=name;dataColumns=XVALUE,YVALUE,AUSGABEAUFSCHLAG,DATE_FORMATTED,YVALUE_FORMATTED,NAV_FORMATTED,WA__WHRNG_ISO,ZEITRAUM;columns=ISIN,XVALUE,YVALUE,AUSGABEAUFSCHLAG,DATE_FORMATTED,YVALUE_FORMATTED,NAV_FORMATTED,WA__WHRNG_ISO,ZEITRAUM;orderColumns=ISIN,XVALUE;groupColumns=XVALUE,YVALUE,AUSGABEAUFSCHLAG,DATE_FORMATTED,YVALUE_FORMATTED,NAV_FORMATTED,WA__WHRNG_ISO,ZEITRAUM";
const DEV_GEM_FUNDLIST_ENDPOINT =
  "https://datahub.dev.erste-group.net/datahubService/data/dds/groupByname/GEM_FUNDLIST";
// FIXME: Factsheet endpoint is blocked by Cross-Origin.
const DEV_GEM_FACTSHEET_ENDPOINT =
  "https://data-dev.erste-group.net/public/gem/erste-am/GEM_FACTSHEET;ddsSources=WARNINGS,WARNINGS_META,ESMA_TEXT_ONLY";

const CTA_ENDPOINT =
  "https://login.sparkasse.at/sts/oauth/authorize?response_type=token&client_id=georgeclient&state=trading/search";

const CTA_SK_ENDPOINT= "https://www.slsp.sk/george-login";
const CTA_RO_ENDPOINT= "https://www.bcr.ro/ro/persoane-fizice/digital-banking/cont-online-george";
const CTA_HR_ENDPOINT= "https://george.erstebank.hr/login/";

const MONTHLY_RATE_DEFAULT = 100;
const MONTHLY_RATE_DEFAULT_SK = 50;
const MONTHLY_RATE_MIN = 0;
const MONTHLY_RATE_MAX = 10000;
const MONTHLY_RATE_STEP = 100;
const DEPOSIT_DEFAULT = 3000;
const DEPOSIT_DEFAULT_SK = 0;
const INIT_DEPOSIT_MIN = 0;
const INIT_DEPOSIT_MAX = 1000000;
const INIT_DEPOSIT_STEP = 5000;
const INDEXED_RATE_DEFAULT = 0;

const COLOR = {
  blue1: "#0078b4",
  blue2: "#40a3d5",
  blue3: "#dff2fd",
  orange1: "#eca72c",
  orange2: "#ff7900",
  orange3: "#d96700",
  grey1: "#f5f8fa",
  grey2: "#8a8a8a",
  grey3: "#84c0c6",
  grey4: "#2d3c4a",
  grey5: "#dce4ea",
  grey6: "#313a45",
  purple: "#a184c6",
  grey7: "#999",
  grey8: "#ececec",
  grey9: "#1d1d1d",
  grey10: "rgba(0, 0, 0, 0.1)",
  grey11: "rgba(255, 255, 255, 0.95)",
  red1: "#ff0000",
  blueTransparent: "rgba(0,160,247,0.1)",
};

const CHART_COLOR_SET = [COLOR.blue1, COLOR.grey3, COLOR.orange1, COLOR.blue2, COLOR.purple];

export {
  PROD_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT,
  PROD_GEM_FUNDLIST_ENDPOINT,
  PROD_GEM_FACTSHEET_ENDPOINT,
  ERSTE_REAL_ESTATE_GRAPHICDATA_PERFORMANCE_ENDPOINT,
  ERSTE_REAL_ESTATE_FUNDLIST_ENDPOINT,
  ERSTE_REAL_ESTATE_FACTSHEET_ENDPOINT,
  ABU_ONLINE_PROD_GEM_FUNDLIST_ENDPOINT,
  ABU_ONLINE_PROD_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT,
  ABU_ONLINE_PROD_GEM_FACTSHEET_ENDPOINT,
  UAT_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT,
  UAT_GEM_FUNDLIST_ENDPOINT,
  UAT_GEM_FACTSHEET_ENDPOINT,
  DEV_GEM_GRAPHICDATA_PERFORMANCE_ENDPOINT,
  DEV_GEM_FUNDLIST_ENDPOINT,
  DEV_GEM_FACTSHEET_ENDPOINT,
  CTA_ENDPOINT,
  CTA_SK_ENDPOINT,
  CTA_RO_ENDPOINT,
  CTA_HR_ENDPOINT,
  MONTHLY_RATE_DEFAULT,
  MONTHLY_RATE_DEFAULT_SK,
  MONTHLY_RATE_MIN,
  MONTHLY_RATE_MAX,
  MONTHLY_RATE_STEP,
  DEPOSIT_DEFAULT,
  DEPOSIT_DEFAULT_SK,
  INIT_DEPOSIT_MIN,
  INIT_DEPOSIT_MAX,
  INIT_DEPOSIT_STEP,
  INDEXED_RATE_DEFAULT,
  COLOR,
  CHART_COLOR_SET,
};
